import algoliasearch from 'algoliasearch/lite'

export default function VueInstantSearchPlugin({ $config: { ALGOLIA_APPLICATION_ID, ALGOLIA_API_KEY, ALGOLIA_VARIANTS_INDEX_NAME } }, inject) {
  const searchClient = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_API_KEY)

  inject('searchClient', searchClient)
}